import { render, staticRenderFns } from "./my-msg.vue?vue&type=template&id=a9520d38&scoped=true&"
import script from "./my-msg.vue?vue&type=script&lang=js&"
export * from "./my-msg.vue?vue&type=script&lang=js&"
import style0 from "./my-msg.vue?vue&type=style&index=0&id=a9520d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9520d38",
  null
  
)

export default component.exports